import { __assign } from "tslib";
import { isa as __isa, } from "@aws-sdk/smithy-client";
export var Event;
(function (Event) {
    Event.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    Event.isa = function (o) { return __isa(o, "Event"); };
})(Event || (Event = {}));
export var InvalidInputException;
(function (InvalidInputException) {
    InvalidInputException.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    InvalidInputException.isa = function (o) { return __isa(o, "InvalidInputException"); };
})(InvalidInputException || (InvalidInputException = {}));
export var PutEventsRequest;
(function (PutEventsRequest) {
    PutEventsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    PutEventsRequest.isa = function (o) { return __isa(o, "PutEventsRequest"); };
})(PutEventsRequest || (PutEventsRequest = {}));
//# sourceMappingURL=index.js.map